<template>
  <vx-card>
    <vs-table stripe :data="users">
      <template slot="thead">
        <vs-th>No</vs-th>
        <vs-th class="text-center">Nama Site</vs-th>
        <vs-th class="text-center">IP Addr</vs-th>
        <vs-th class="text-right">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="indextr">
            {{ indextr + 1 }}
          </vs-td>

          <vs-td class="text-center" :data="data[indextr].name">
            {{ data[indextr].name }}
          </vs-td>

          <vs-td class="text-center" :data="data[indextr].ip">
            {{ data[indextr].ip }}
          </vs-td>

          <vs-td class="text-right">
            <router-link to="/">
              <feather-icon icon="EyeIcon" svgClasses="icon" />
            </router-link>
            <router-link to="/">
              <feather-icon icon="EditIcon" svgClasses="icon" />
            </router-link>
            <router-link to="/">
              <feather-icon icon="Trash2Icon" svgClasses="icon" />
            </router-link>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      users: [
        {
          name: "Site 1",
          ip: "172.16.0.22",
        },
        {
          name: "Site 2",
          ip: "172.16.0.23",
        },
        {
          name: "Site 3",
          ip: "172.16.0.24",
        },
        {
          name: "Site 4",
          ip: "172.16.0.25",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.icon {
  margin: 0 5px;
}
.text-center:deep(.vs-table-text) {
  justify-content: center;
}
.text-right:deep(.vs-table-text) {
  justify-content: flex-end;
}
</style>
